import { InjectionToken } from '@angular/core';
import { AnalyticsCategory } from './analytics-categories';
import { AnalyticsAction } from './analytics-actions';

export interface AnalyticEvent {
  category: AnalyticsCategory;
  action: AnalyticsAction;
  name?: string;
  value?: number;
}

export interface AnalyticTracking {
  trackPageView(pageTitle: string, url: string): void;
  trackEvent(event: AnalyticEvent): void;
  setUserId(userId: string): void;
}

export const AnalyticService = new InjectionToken<AnalyticTracking>('Analytic Provider');
